import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=536b9b05&scoped=true&"
import script from "./Common.vue?vue&type=script&lang=js&"
export * from "./Common.vue?vue&type=script&lang=js&"
import style0 from "./Common.vue?vue&type=style&index=0&id=536b9b05&scoped=true&lang=css&"
import style1 from "./Common.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b9b05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536b9b05')) {
      api.createRecord('536b9b05', component.options)
    } else {
      api.reload('536b9b05', component.options)
    }
    module.hot.accept("./Common.vue?vue&type=template&id=536b9b05&scoped=true&", function () {
      api.rerender('536b9b05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MemberGroup/Common.vue"
export default component.exports